(function () {
  'use strict';

  var CONFIG = {
    oneTimeValue: 'onetime',
    oneTimeLabel: 'One-time only',
    oneTimeGroupLabel: 'Pay Full Price',
    subscriptionGroupLabel: 'Subscribe and Save up to {max}%',
    subscriptionGroupLabelNoDiscount: 'Subscribe and Save',
    planLabel: '{name} – Save {discount}%',
    label: 'Delivery frequency',
    mixedLabel: 'Choose a delivery option',
    itemSelector: '.rebuy-cart__flyout-item',
    containerId: 'cart-frequency-selector',
    autoAlignNewItems: true,
    storageKey: 'cfs:choice',
    debounceMs: 200
  };

  var productCache = {};
  var busy = false;
  var syncTimer = null;
  var optionsSignature = '';

  /* ---------- helpers ---------- */

  function rebuyReady() {
    return window.Rebuy && window.Rebuy.Cart &&
      typeof window.Rebuy.Cart.getItems === 'function' &&
      typeof window.Rebuy.Cart.switchItemToFrequency === 'function';
  }

  function getItems() {
    try { return window.Rebuy.Cart.getItems() || []; } catch (e) { return []; }
  }

  function readChoice() {
    try { return window.sessionStorage.getItem(CONFIG.storageKey); } catch (e) { return null; }
  }

  function saveChoice(value) {
    try { window.sessionStorage.setItem(CONFIG.storageKey, value); } catch (e) { /* ignore */ }
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productCache[handle] = fetch(root + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  /* ---------- discount (dynamic) ---------- */

  function cleanPercent(v) {
    v = Number(v);
    if (!isFinite(v) || v <= 0) return 0;
    if (v > 100) return 0; 
    return Math.round(v);
  }

  function discountsFromAllocations(product) {
    var map = {};
    if (!product || !product.variants) return map;
    product.variants.forEach(function (variant) {
      (variant.selling_plan_allocations || []).forEach(function (a) {
        if (map[a.selling_plan_id] != null) return;
        var base = Number(a.compare_at_price) || Number(variant.price) || 0;
        var price = Number(a.price);
        if (base > 0 && isFinite(price) && price < base) {
          map[a.selling_plan_id] = cleanPercent((base - price) / base * 100);
        }
      });
    });
    return map;
  }

  function discountFromAdjustment(plan) {
    var adj = plan && plan.price_adjustments && plan.price_adjustments[0];
    if (!adj || adj.value_type !== 'percentage') return 0;
    var v = Number(adj.value) || 0;
    if (v > 0 && v < 1) v = v * 100; 
    return cleanPercent(v);
  }

  function plansOf(product) {
    var plans = [];
    if (!product || !product.selling_plan_groups) return plans;
    var fromPrices = discountsFromAllocations(product);
    product.selling_plan_groups.forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) {
        if (p._cfsDiscount == null) {
          p._cfsDiscount = fromPrices[p.id] != null ? fromPrices[p.id] : discountFromAdjustment(p);
        }
        plans.push(p);
      });
    });
    return plans;
  }

  function planDiscount(plan) {
    return plan && plan._cfsDiscount != null ? plan._cfsDiscount : discountFromAdjustment(plan);
  }

  function escapeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function dominantValue(values) {
    var counts = {}, best = null;
    values.forEach(function (v) {
      if (v === CONFIG.oneTimeValue) return;
      counts[v] = (counts[v] || 0) + 1;
      if (!best || counts[v] > counts[best]) best = v;
    });
    return best || CONFIG.oneTimeValue;
  }

  function currentValue(item) {
    var a = item.selling_plan_allocation;
    return a && a.selling_plan ? a.selling_plan.name : CONFIG.oneTimeValue;
  }

  function getEligible(items) {
    return Promise.all(items.map(function (item) {
      return fetchProduct(item.handle).then(function (product) {
        return { item: item, plans: plansOf(product) };
      });
    })).then(function (rows) {
      return rows.filter(function (r) { return r.plans.length > 0; });
    });
  }

  function switchItem(item, value) {
    return new Promise(function (resolve, reject) {
      window.Rebuy.Cart.switchItemToFrequency(item, value, resolve, reject);
    });
  }

  /* ---------- UI ---------- */

  function findMount() {
    var block = document.getElementById(CONFIG.containerId);
    if (block) return { el: block, mode: 'inside' };

    var firstItem = document.querySelector(CONFIG.itemSelector);
    if (firstItem && firstItem.parentElement) return { el: firstItem.parentElement, mode: 'before' };
    return null;
  }

  function ensureWidget() {
    var existing = document.querySelector('[data-cfs]');
    if (existing && document.body.contains(existing)) return existing;

    var mount = findMount();
    if (!mount) return null;

    var wrap = document.createElement('div');
    wrap.className = 'cfs';
    wrap.setAttribute('data-cfs', '');
    wrap.hidden = true;
    wrap.innerHTML =
      '<label class="cfs__label" for="cfs-select">' + CONFIG.label + '</label>' +
      '<select id="cfs-select" class="rebuy-select cfs__select" aria-label="' + CONFIG.label + '"></select>' +
      '<p class="cfs__error" role="alert" hidden></p>';

    if (mount.mode === 'inside') {
      mount.el.appendChild(wrap);
    } else {
      mount.el.parentNode.insertBefore(wrap, mount.el);
    }

    wrap.querySelector('select').addEventListener('change', function (e) {
      var value = e.target.value;
      if (!value) return;
      saveChoice(value);
      applyToAll(value);
    });

    optionsSignature = '';
    return wrap;
  }

  function buildOptions(select, plans) {
    var sig = plans.map(function (p) { return p.id + ':' + planDiscount(p); }).join(',');
    if (sig === optionsSignature) return;
    optionsSignature = sig;

    var max = 0;
    plans.forEach(function (p) { max = Math.max(max, planDiscount(p)); });

    var groupLabel = max > 0
      ? CONFIG.subscriptionGroupLabel.replace('{max}', max)
      : CONFIG.subscriptionGroupLabelNoDiscount;

    var html =
      '<option value="" data-cfs-mixed disabled hidden>' + CONFIG.mixedLabel + '</option>' +
      '<optgroup label="' + escapeAttr(CONFIG.oneTimeGroupLabel) + '">' +
        '<option value="' + CONFIG.oneTimeValue + '">' + CONFIG.oneTimeLabel + '</option>' +
      '</optgroup>' +
      '<optgroup label="' + escapeAttr(groupLabel) + '">';

    plans.forEach(function (p) {
      var d = planDiscount(p);
      var text = d > 0
        ? CONFIG.planLabel.replace('{name}', p.name).replace('{discount}', d)
        : p.name;
      html += '<option value="' + escapeAttr(p.name) + '">' + escapeAttr(text) + '</option>';
    });

    html += '</optgroup>';
    select.innerHTML = html;
  }

  function setLoading(wrap, on) {
    if (!wrap) return;
    wrap.classList.toggle('is-loading', on);
    wrap.querySelector('select').disabled = on;
  }

  function showError(wrap, msg) {
    if (!wrap) return;
    var p = wrap.querySelector('.cfs__error');
    p.textContent = msg || '';
    p.hidden = !msg;
  }

  /* ---------- switching ---------- */

  function settle() {
    return new Promise(function (resolve) {
      var C = window.Rebuy && window.Rebuy.Cart;
      var started = Date.now();
      (function poll() {
        var waited = Date.now() - started;
        var quiet = true;
        try {
          if (C && typeof C.isCartQuiescent === 'function') quiet = !!C.isCartQuiescent();
        } catch (e) { quiet = true; }
        if ((waited >= 300 && quiet) || waited >= 3000) return resolve();
        setTimeout(poll, 150);
      })();
    });
  }

  function mismatched(value) {
    return getEligible(getItems()).then(function (rows) {
      return rows.filter(function (r) { return currentValue(r.item) !== value; });
    });
  }

  function runPass(value) {
    var attempted = {};
    function step() {
      return settle().then(function () { return mismatched(value); }).then(function (rows) {
        var next = null;
        for (var i = 0; i < rows.length; i++) {
          if (!attempted[rows[i].item.key]) { next = rows[i].item; break; }
        }
        if (!next) return;
        attempted[next.key] = true;
        return switchItem(next, value).catch(function () {}).then(step);
      });
    }
    return step();
  }

  function applyToAll(value) {
    if (busy || !rebuyReady()) return;
    busy = true;
    setLoading(document.querySelector('[data-cfs]'), true);
    showError(document.querySelector('[data-cfs]'), '');

    runPass(value)
      .then(settle)
      .then(function () { return mismatched(value); })
      .then(function (left) { return left.length ? runPass(value).then(settle) : null; }) // one retry
      .then(function () { return mismatched(value); })
      .then(function (left) {
        busy = false;
        var wrap = document.querySelector('[data-cfs]');
        setLoading(wrap, false);
        showError(wrap, left.length ? 'Some items could not be updated. Please try again.' : '');
        scheduleSync();
      });
  }

  /* ---------- sync ---------- */

  function sync() {
    if (busy || !rebuyReady()) return;
    var wrap = ensureWidget();
    if (!wrap) return;

    getEligible(getItems()).then(function (rows) {
      wrap = document.querySelector('[data-cfs]');
      if (!wrap) return;

      if (!rows.length) { wrap.hidden = true; return; }
      wrap.hidden = false;

      var select = wrap.querySelector('select');
      buildOptions(select, rows[0].plans);

      var values = rows.map(function (r) { return currentValue(r.item); });
      var allSame = values.every(function (v) { return v === values[0]; });

      if (allSame) {
        select.value = values[0];
        saveChoice(values[0]);
        return;
      }

      var saved = readChoice();
      var choice = (saved && saved !== CONFIG.oneTimeValue) ? saved : dominantValue(values);
      if (CONFIG.autoAlignNewItems && choice) {
        select.value = choice;
        applyToAll(choice);
      } else {
        select.value = '';
      }
    });
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, CONFIG.debounceMs);
  }

  function init() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (!(t.closest && t.closest('[data-cfs]'))) { scheduleSync(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });

    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();